import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FlexLayoutModule } from '@angular/flex-layout';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';
import { ImageCropperModule } from 'ngx-image-cropper';

import { PlatformImageCropperComponent } from './components/app-platform-image-cropper/app-platform-image-cropper.component';

@NgModule({
    imports: [TranslateModule.forChild(), CommonModule, FlexLayoutModule, ImageCropperModule, MatButtonModule],
    exports: [PlatformImageCropperComponent],
    declarations: [PlatformImageCropperComponent],
    providers: []
})
export class PlatformImageCropperModule {}
